export default "__VITE_ASSET__ee429031__"